<h1 mat-dialog-title>Geschlecht</h1>

<div mat-dialog-content>
    <div class="geschlecht-wahl">
        <button
            type="button"
            class="geschlecht-wahl__btn"
            [class.geschlecht-wahl__btn--active]="geschlechtId === 1"
            data-cy="geschlecht-dialog-m"
            (click)="dialogRef.close(1)"
        >
            m
        </button>
        <button
            type="button"
            class="geschlecht-wahl__btn"
            [class.geschlecht-wahl__btn--active]="geschlechtId === 2"
            data-cy="geschlecht-dialog-w"
            (click)="dialogRef.close(2)"
        >
            w
        </button>
    </div>
</div>
<div mat-dialog-actions>
    <button mat-button data-cy="geschlecht-dialog-abort" (click)="dialogRef.close()">Abbrechen</button>
</div>
